/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The kind of source (http or function)
 */
export const SetSourceEnvironmentLinkRequestBodySourceKind = {
  Http: "http",
  Function: "function",
} as const;
/**
 * The kind of source (http or function)
 */
export type SetSourceEnvironmentLinkRequestBodySourceKind = ClosedEnum<
  typeof SetSourceEnvironmentLinkRequestBodySourceKind
>;

export type SetSourceEnvironmentLinkRequestBody = {
  /**
   * The ID of the environment to link
   */
  environmentId: string;
  /**
   * The kind of source (http or function)
   */
  sourceKind: SetSourceEnvironmentLinkRequestBodySourceKind;
  /**
   * The slug of the source
   */
  sourceSlug: string;
};

/** @internal */
export const SetSourceEnvironmentLinkRequestBodySourceKind$outboundSchema:
  z.ZodMiniEnum<typeof SetSourceEnvironmentLinkRequestBodySourceKind> = z.enum(
    SetSourceEnvironmentLinkRequestBodySourceKind,
  );

/** @internal */
export type SetSourceEnvironmentLinkRequestBody$Outbound = {
  environment_id: string;
  source_kind: string;
  source_slug: string;
};

/** @internal */
export const SetSourceEnvironmentLinkRequestBody$outboundSchema: z.ZodMiniType<
  SetSourceEnvironmentLinkRequestBody$Outbound,
  SetSourceEnvironmentLinkRequestBody
> = z.pipe(
  z.object({
    environmentId: z.string(),
    sourceKind: SetSourceEnvironmentLinkRequestBodySourceKind$outboundSchema,
    sourceSlug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      environmentId: "environment_id",
      sourceKind: "source_kind",
      sourceSlug: "source_slug",
    });
  }),
);

export function setSourceEnvironmentLinkRequestBodyToJSON(
  setSourceEnvironmentLinkRequestBody: SetSourceEnvironmentLinkRequestBody,
): string {
  return JSON.stringify(
    SetSourceEnvironmentLinkRequestBody$outboundSchema.parse(
      setSourceEnvironmentLinkRequestBody,
    ),
  );
}
